import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pdp-schema" }

import { computed, inject } from 'vue';
import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';
import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSchema',
  setup(__props) {

const toLitiumMediaUrl = inject(toLitiumMediaUrlKey);
const { page, cart } = useContext();
const product = computed(() => page.value?.dataJson?.product || {});
const canonical = computed(() => page.value?.canonical);

const description = computed(() => {
  const htmlString = product.value.pdpDetails?.description?.productDescription || '';
  const removeHtmlTagsRegex = /<[^>]*>/gm;

  return htmlString.replace(removeHtmlTagsRegex, '');
});

const availability = computed(() => (product.value.otherVariants?.find((v) => v.inStock)
  ? 'https://schema.org/InStock'
  : 'https://schema.org/OutOfStock'));

const price = computed(() => product.value.otherVariants?.[0]?.campaignPrice
    || product.value.otherVariants?.[0]?.price);

const imageUrls = computed(() => product.value.images?.map((image) => toLitiumMediaUrl?.(image)) || undefined);

const name = computed(() => product.value.fields?._name);

const currency = computed(() => cart.value?.currency.id);

const mainColor = computed(() => product.value.fields?.Color?.name);

const color = computed(() => product.value.fields?.ColorHue?.name);

const articleNumber = computed(() => product.value.id);

const jsonld = computed(() => {
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    sku: articleNumber.value,
    mpn: articleNumber.value,
    brand: {
      '@type': 'Brand',
      name: 'Didriksons',
    },
    name: name.value,
    pattern: color.value,
    color: mainColor.value,
    image: imageUrls.value,
    description: description.value,
    offers: {
      '@type': 'Offer',
      url: canonical.value,
      priceCurrency: currency.value,
      price: price.value,
      availability: availability.value,
      itemCondition: 'https://schema.org/NewCondition',
    },
  };

  return JSON.stringify(schema);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(jsonld))
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
          key: 0,
          type: "application/ld+json",
          innerHTML: _unref(jsonld)
        }, null, 8, ["innerHTML"]))
      : _createCommentVNode("", true)
  ]))
}
}

})